import gql from 'graphql-tag';

export default gql`
  query notificationMessages($pagination: Pagination!, $storeId: Int) {
    notificationMessages(pagination: $pagination, storeId: $storeId) {
      totalPage
      totalResults
      data {
        id
        readStatus
        messageType
        title
        content
        createdAt
        updatedAt
        data {
          type
          orderId
          navType
          navValue
        }
        subMessages {
          id
          readStatus
          messageType
          title
          content
          createdAt
          updatedAt
          data {
            type
            orderId
            navType
            navValue
          }
        }
      }
    }
  }
`;
